import "./../../../NodeTypes/Presentation/Content/Form.js";
import "./../../../NodeTypes/Presentation/Content/Hero.js";
import * as CookieConsent from 'vanilla-cookieconsent';

// Cookie consent configuration
const cookieConsentConfig = {
    guiOptions: {
        consentModal: {
            layout: "bar",
            position: "bottom",
            equalWeightButtons: true,
            flipButtons: false
        },
        preferencesModal: {
            layout: 'box',
            position: 'right',
            equalWeightButtons: true,
            flipButtons: false,
        }
    },
    disablePageInteraction: true,
    categories: {
        necessary: {
            readOnly: true
        },
        analytics: {
            services: {
                clarity: {
                    label: '<a href="https://clarity.microsoft.com/" target="_blank">Microsoft Clarity</a>',
                    onAccept: () => {
                        console.log('Microsoft Clarity accepted');
                        initMicrosoftClarity();
                    },
                    onReject: () => {
                        console.log('Microsoft Clarity rejected');
                        // Stop and remove clarity if it was loaded
                        if (window.clarity) {
                            window.clarity('stop');
                            delete window.clarity;
                        }
                    },
                    cookies: [
                        {
                            name: /_clarity/,
                        },
                        {
                            name: /^_clsk$/,
                        },
                        {
                            name: /^_clck$/,
                        }
                    ],
                }
            }
        },
        functionality: {},
        marketing: {}
    },
    language: {
        default: 'pl',
        autoDetect: 'browser',
        translations: {
            en: {
                consentModal: {
                    title: 'Cookie Information',
                    description: 'This website uses cookies to ensure its proper functioning, to use Google Analytics analytical tools, marketing tools (Facebook Custom Audiences), and social media plugins (Facebook, LinkedIn, Twitter). Details can be found in the Cookie Policy. If you consent to the use of cookies, click the "Accept" button. Consent is voluntary. If you do not want to give consent, want to limit its scope, or want to withdraw previously given consent, go to "Settings". By clicking "Accept" you consent to the installation and storage of cookie files on your end device. You can change cookie settings at any time through your browser settings.',
                    acceptAllBtn: 'Accept',
                    acceptNecessaryBtn: 'Only necessary',
                    showPreferencesBtn: 'Settings',
                    footer: ''
                },
                preferencesModal: {
                    title: 'Consent Preferences Center',
                    acceptAllBtn: 'Accept all',
                    acceptNecessaryBtn: 'Only necessary',
                    savePreferencesBtn: 'Save',
                    closeIconLabel: 'Close modal',
                    serviceCounterLabel: 'Service|Services',
                    sections: [
                        {
                            title: "What are cookies?",
                            description: "Cookies are small text files stored on your device (computer, smartphone, tablet) while browsing the website. They allow the website to remember information about your visit, such as language preferences or login data (if applicable), which makes it easier to use the website during subsequent visits."
                        },
                        {
                            title: "Necessary cookies <span class=\"pm__badge\">Always selected</span>",
                            description: "These cookies are crucial for the proper functioning of the website and enable you to use its basic functions, such as filling out and submitting the contest form, displaying messages tailored to your actions. Without these cookies, the website could not function properly.",
                            linkedCategory: "necessary"
                        },
                        {
                            title: "Functional cookies",
                            description: "These cookies allow the website to remember your choices (e.g., language preferences) and customize the website to your needs, increasing user comfort. In the context of this website, they may be used to remember whether you have already consented to the cookie policy.",
                            linkedCategory: "functionality"
                        },
                        {
                            title: "Analytical cookies",
                            description: "We may use these cookies to collect information about how users use the website, including the number of visits, traffic sources, and how they navigate the website. This information helps us analyze and improve the website's performance. For this specific website, their use will be limited to traffic analysis in the context of the contest.",
                            linkedCategory: "analytics"
                        },
                        {
                            title: "Marketing cookies (optional)",
                            description: "In the future, if we decide to conduct marketing activities related to the contest on this website, we may use these cookies to track the effectiveness of advertising campaigns and deliver personalized content to you.",
                            linkedCategory: "marketing"
                        },
                        {
                            title: "How to manage cookies?",
                            description: "Most web browsers accept cookies by default. However, you can change your browser settings to block cookies or receive notifications about their storage. Remember that blocking certain types of cookies may affect the website's functionality and prevent you from participating in the contest (this particularly applies to necessary cookies). Detailed information about managing cookies can be found in your web browser settings and in the browser's help section."
                        },
                    ]
                }
            },
            pl: {
                consentModal: {
                    title: 'Informacja o cookies',
                    description: 'Strona wykorzystuje pliki cookies w celu prawidłowego jej działania, korzystania z narzędzi analitycznych Google Analytics, marketingowych (Facebook Custom Audiences), wtyczek społecznościowych (Facebook, LinkedIN, Twitter). Szczegóły znajdują się w Polityce cookies. Jeżeli wyrażasz zgodę na wykorzystywanie plików cookies, kliknij w przycisk „Akceptuję”. Wyrażenie zgody jest dobrowolne. Jeśli nie chcesz wyrazić zgody, chcesz ograniczyć jej zakres lub chcesz wycofać zgodę uprzednio udzieloną przejdź do „Ustawień”. Poprzez kliknięcie „Akceptuję” wyrażasz zgodę na zainstalowanie i przechowywanie plików typu cookie na Twoim urządzeniu końcowym. Za pomocą ustawień przeglądarki możesz w każdym czasie zmienić ustawienia w zakresie cookies.',
                    acceptAllBtn: 'Akceptuje',
                    acceptNecessaryBtn: 'Tylko niezbędne',
                    showPreferencesBtn: 'Ustawienia',
                    footer: ''
                },
                preferencesModal: {
                    title: 'Centrum preferencji zgody',
                    acceptAllBtn: 'Zaakceptuj wszystkie',
                    acceptNecessaryBtn: 'Tylko niezbędne',
                    savePreferencesBtn: 'Zapisz',
                    closeIconLabel: 'Zamknij modal',
                    serviceCounterLabel: 'Usługa|Usługi',
                    sections: [
                        {

                            title: "Czym są pliki cookies?",
                            description: "Pliki cookies (ciasteczka) to niewielkie pliki tekstowe przechowywane na Twoim urządzeniu (komputerze, smartfonie, tablecie) podczas przeglądania Strony. Umożliwiają one Stronie zapamiętanie informacji o Twojej wizycie, takich jak preferencje językowe czy dane logowania (jeśli są stosowane), co ułatwia korzystanie ze Strony podczas kolejnych wizyt."
                        },
                        {
                            title: "Niezbędne pliki cookies <span class=\"pm__badge\">Zawsze wybrane</span>",
                            description: "Te pliki cookies są kluczowe dla prawidłowego funkcjonowania Strony i umożliwiają Ci korzystanie z jej podstawowych funkcji, takich jak wypełnienie i przesłanie formularza konkursowego, wyświetlanie komunikatów dopasowanych do Twoich działań.. Bez tych plików cookies Strona nie mogłaby działać poprawnie.",
                            linkedCategory: "necessary"
                        },
                        {
                            title: "Funkcjonalne pliki cookies",
                            description: "Te pliki cookies pozwalają Stronie zapamiętać Twoje wybory (np. preferencje językowe) i dostosować Stronę do Twoich potrzeb, zwiększając komfort użytkowania. W kontekście tej Strony mogą być wykorzystywane do zapamiętania, czy wyraziłeś już zgodę na politykę cookies.",
                            linkedCategory: "functionality"
                        },
                        {
                            title: "Analityczne pliki cookies",
                            description: "Możemy wykorzystywać te pliki cookies w celu zbierania informacji o sposobie korzystania ze Strony przez użytkowników, w tym o liczbie odwiedzin, źródłach ruchu oraz sposobie poruszania się po Stronie. Informacje te pomagają nam analizować i ulepszać działanie Strony. W przypadku tej konkretnej Strony, ich użycie będzie ograniczone do analizy ruchu w kontekście konkursu.",
                            linkedCategory: "analytics"
                        },
                        {
                            title: "Marketingowe pliki cookies (opcjonalnie)",
                            description: "W przyszłości, jeśli zdecydujemy się na prowadzenie działań marketingowych związanych z konkursem na tej Stronie, możemy wykorzystywać te pliki cookies w celu śledzenia skuteczności kampanii reklamowych i dostarczania Ci spersonalizowanych treści.",
                            linkedCategory: "marketing"
                        },
                        {
                            title: "Jak zarządzać plikami cookies?",
                            description: "Większość przeglądarek internetowych domyślnie akceptuje pliki cookies. Możesz jednak zmienić ustawienia swojej przeglądarki, aby blokować pliki cookies lub otrzymywać powiadomienia o ich zapisywaniu. Pamiętaj, że zablokowanie niektórych rodzajów plików cookies może wpłynąć na funkcjonalność Strony i uniemożliwić Ci wzięcie udziału w konkursie (szczególnie dotyczy to niezbędnych plików cookies). Szczegółowe informacje o zarządzaniu plikami cookies można znaleźć w ustawieniach Twojej przeglądarki internetowej oraz w sekcji pomocy przeglądarki."
                        },
                    ]
                }
            }
        }
    },
    onFirstConsent: ({cookie}) => {
        console.log('onFirstConsent fired', cookie);
    },
    onConsent: ({cookie}) => {
        console.log('onConsent fired', cookie);
    },
    onChange: ({cookie, changedCategories}) => {
        console.log('onChange fired', cookie, changedCategories);
    }
};

// Initialize Microsoft Clarity
function initMicrosoftClarity() {
    if (typeof window.clarity === 'undefined') {
        console.log('Loading Microsoft Clarity...');
        (function(c,l,a,r,i,t,y){
            c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
            t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
            y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "srjairoavm");
    }
}

// Main JavaScript file for Hb180.Site

// Alpine.js setup (if needed in the future)
// import Alpine from 'alpinejs'
// window.Alpine = Alpine
// Alpine.start()

// Basic site functionality
document.addEventListener('DOMContentLoaded', function() {
    console.log('Hb180.Site JavaScript loaded');

    // Initialize cookie consent
    CookieConsent.run(cookieConsentConfig);

    // Add any global site functionality here
    initSiteFeatures();
});

function initSiteFeatures() {
    console.log('initSiteFeatures');
    initSmoothScrolling();
}

function initSmoothScrolling() {
    const links = document.querySelectorAll('a[href^="#"]');

    links.forEach(link => {
        link.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            if (href === '#') return;

            const targetId = href.substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                e.preventDefault();
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });
}

// Export functions for global use
window.HB180Site = {
    initSiteFeatures,
    initSmoothScrolling
};
